import React from "react";
import { Route } from "react-router-dom";
import AccountPayableRoutes from "./account-payable";
import AccountReceiveableRoutes from "./account-receiveable";
import AssetReportRoutes from "./asset-report";
import BalanceSheetRoutes from "./balance-sheet";
import CashBankRoutes from "./cash-bank";
import CashFlowRoutes from "./cash-flow";
import CustomerPerformanceRoutes from "./customer-performance";
import CustomerReportRoutes from "./customer-report";
import IncomeStatementRoutes from "./income-statement";
import PriceComparisonRoutes from "./price-comparison";
import PurchasingReportRoutes from "./purchasing-report";
import SalesPerformanceRoutes from "./sales-performance";
import SalesReportRoutes from "./sales-report";
import TrackingSalesRoutes from "./tracking-sales";
import UncollectedDebtRoutes from "./uncollected-debt";
import VisitSalesRoutes from "./visit-sales";
import WorkSheetRoutes from "./work-sheet";
import AcceptanceReportRoutes from "./acceptance-report";
import GeneralLedgerRoutes from "./general-ledger";
import TrackingPurchasingRoutes from "./tracking-purchasing";
import RankingSalesRoutes from "./ranking-sales";
import CashReportRoutes from "./cash-report";

export default function ReportRoutes( props ) {
    return (
    <Route path="/report">
        {AcceptanceReportRoutes(props)}
        {AccountPayableRoutes(props)}
        {AccountReceiveableRoutes(props)}
        {AssetReportRoutes(props)}
        {BalanceSheetRoutes(props)}
        {CashBankRoutes(props)}
        {CashFlowRoutes(props)}
        {CashReportRoutes(props)}
        {CustomerPerformanceRoutes(props)}
        {CustomerReportRoutes(props)}
        {GeneralLedgerRoutes(props)}
        {IncomeStatementRoutes(props)}
        {PriceComparisonRoutes(props)}
        {PurchasingReportRoutes(props)}
        {SalesPerformanceRoutes(props)}
        {SalesReportRoutes(props)}
        {TrackingPurchasingRoutes(props)}
        {TrackingSalesRoutes(props)}
        {UncollectedDebtRoutes(props)}
        {VisitSalesRoutes(props)}
        {WorkSheetRoutes(props)}
        {RankingSalesRoutes(props)}
    </Route>
    )
}